import { useState } from 'react';

import {
  AttendancePageHeader,
  AttendanceSummary,
  AttendanceTable,
} from './components';
import MailModal from './components/AttendanceTable/MailModal';
import GenerateReportModal from './components/AttendanceTable/GenerateReportModal';

const CentralAttendanceList = () => {
  const [isMailModalOpen, setIsMailModalOpen] = useState<boolean>(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);

  const openMailModal = () => {
    setIsMailModalOpen(true);
  };

  const closeMailModal = () => {
    setIsMailModalOpen(false);
  };

  const openReportModal = () => {
    setIsReportModalOpen(true);
  };

  const closeReportModal = () => {
    setIsReportModalOpen(false);
  };

  return (
    <div className="container p-10">
      <MailModal isModalOpen={isMailModalOpen} closeModal={closeMailModal} />
      <GenerateReportModal
        isModalOpen={isReportModalOpen}
        closeModal={closeReportModal}
      />
      <AttendancePageHeader openReportModal={openReportModal} />
      <AttendanceSummary />
      <AttendanceTable openMailModal={openMailModal} />
    </div>
  );
};

export default CentralAttendanceList;
